// src/api.js — Client API centralisé

const API_BASE = '/api'

async function request(path, options = {}) {
  const token = localStorage.getItem('hs_token')

  const headers = {
    'Content-Type': 'application/json',
    ...(token ? { 'Authorization': `Bearer ${token}` } : {}),
  }

  const res = await fetch(`${API_BASE}${path}`, {
    ...options,
    headers,
    body: options.body ? JSON.stringify(options.body) : undefined,
  })

  const data = await res.json()
  if (!res.ok) throw new Error(data.message || `Erreur ${res.status}`)
  return data
}

export const api = {
  get:    (path)       => request(path),
  post:   (path, body) => request(path, { method: 'POST',   body }),
  put:    (path, body) => request(path, { method: 'PUT',    body }),
  patch:  (path, body) => request(path, { method: 'PATCH',  body }),
  delete: (path)       => request(path, { method: 'DELETE' }),
}

// ── Auth ─────────────────────────────────────────────────────
export const authApi = {
  login:    (body) => api.post('/auth/login', body),
  register: (body) => api.post('/auth/register', body),
  logout:   ()     => api.post('/auth/logout'),
  me:       ()     => api.get('/auth/me'),
}

// ── Contacts ─────────────────────────────────────────────────
export const contactsApi = {
  list:      (params = {}) => api.get('/contacts?' + new URLSearchParams(params)),
  get:       (id)          => api.get(`/contacts/${id}`),
  create:    (body)        => api.post('/contacts', body),
  update:    (id, body)    => api.put(`/contacts/${id}`, body),
  delete:    (id)          => api.delete(`/contacts/${id}`),
  documents: (id, params)  => api.get(`/contacts/${id}/documents?` + new URLSearchParams(params || {})),
  echanges:  (id)          => api.get(`/contacts/${id}/echanges`),
  familles:  ()            => api.get('/contacts/familles'),
}

// ── Documents ────────────────────────────────────────────────
export const documentsApi = {
  list:        (params = {}) => api.get('/documents?' + new URLSearchParams(params)),
  get:         (id)          => api.get(`/documents/${id}`),
  create:      (body)        => api.post('/documents', body),
  update:      (id, body)    => api.put(`/documents/${id}`, body),
  statut:      (id, statut)  => api.patch(`/documents/${id}/statut`, { statut }),
  transformer: (id, type)    => api.post(`/documents/${id}/transformer`, { type }),
  dupliquer:   (id)          => api.post(`/documents/${id}/dupliquer`),
  delete:      (id)          => api.delete(`/documents/${id}`),
}

// ── Produits ─────────────────────────────────────────────────
export const produitsApi = {
  list:   (params = {}) => api.get('/produits?' + new URLSearchParams(params)),
  get:    (id)          => api.get(`/produits/${id}`),
  create: (body)        => api.post('/produits', body),
  update: (id, body)    => api.put(`/produits/${id}`, body),
  delete: (id)          => api.delete(`/produits/${id}`),
}

// ── Paiements ────────────────────────────────────────────────
export const paiementsApi = {
  list:   (docId) => api.get(`/paiements?document_id=${docId}`),
  create: (body)  => api.post('/paiements', body),
  delete: (id)    => api.delete(`/paiements/${id}`),
}

// ── Échanges ─────────────────────────────────────────────────
export const echangesApi = {
  list:   (params = {}) => api.get('/echanges?' + new URLSearchParams(params)),
  create: (body)        => api.post('/echanges', body),
  update: (id, body)    => api.put(`/echanges/${id}`, body),
  delete: (id)          => api.delete(`/echanges/${id}`),
}

// ── Alertes ──────────────────────────────────────────────────
export const alertesApi = {
  list:   (params = {}) => api.get('/alertes?' + new URLSearchParams(params)),
  create: (body)        => api.post('/alertes', body),
  update: (id, body)    => api.put(`/alertes/${id}`, body),
  delete: (id)          => api.delete(`/alertes/${id}`),
}

// ── Dashboard ────────────────────────────────────────────────
export const dashboardApi = {
  stats: () => api.get('/dashboard'),
}

// ── Paramètres ───────────────────────────────────────────────
export const parametresApi = {
  get:    ()     => api.get('/parametres'),
  update: (body) => api.put('/parametres', body),
}

// ── Stock ───────────────────────────────────────────────────
export const stockApi = {
  list:        (params = {}) => api.get('/stock?' + new URLSearchParams(params)),
  mouvements:  (id)          => api.get(`/stock/${id}/mouvements`),
  ajustement:  (id, body)    => api.post(`/stock/${id}/ajustement`, body),
}

// ── Comptabilité / Écritures ────────────────────────────────
export const ecrituresApi = {
  list:             (params = {}) => api.get('/ecritures?' + new URLSearchParams(params)),
  create:           (body)        => api.post('/ecritures', body),
  update:           (id, body)    => api.put(`/ecritures/${id}`, body),
  delete:           (id)          => api.delete(`/ecritures/${id}`),
  categories:       (params = {}) => api.get('/ecritures/categories?' + new URLSearchParams(params)),
  createCategorie:  (body)        => api.post('/ecritures/categories', body),
  deleteCategorie:  (id)          => api.delete(`/ecritures/${id}/categories`),
}
